module.exports = __webpack_public_path__ + "static/CodeABckground2-32beba73573f8146982b1d4014ce4c03.jpg";